import { render } from "./EditProduitRestreintPage.vue?vue&type=template&id=326c0014&ts=true"
import script from "./EditProduitRestreintPage.vue?vue&type=script&lang=ts"
export * from "./EditProduitRestreintPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__